/**
 * Profile Module
 * Handles user profile management, password changes, and account deletion
 */

export class Profile {
	constructor() {
		this.ajax = window.ajax;
		this.mid = 18; // Module ID for mod_profile

		this.init();
	}

	init() {
		console.log('Profile module initialized');
	}

	/**
	 * Save profile data
	 * @param {HTMLFormElement} form - Profile form element
	 */
	async saveProfile(form) {
		try {
			const formData = new FormData(form);
			const data = {
				action: 'saveProfile',
				...Object.fromEntries(formData)
			};

			const response = await this.ajax.post(`/ajax.php?mid=${this.mid}`, data, {
				dataType: 'json'
			});

			if (response.success) {
				this.showMessage('Профиль успешно сохранён', 'success');
			} else {
				this.showMessage(response.error || 'Ошибка при сохранении профиля', 'error');
			}
		} catch (error) {
			console.error('Error saving profile:', error);
			this.showMessage('Ошибка при сохранении профиля', 'error');
		}

		return false;
	}

	/**
	 * Change user password
	 * @param {HTMLFormElement} form - Password change form element
	 */
	async changePassword(form) {
		try {
			const formData = new FormData(form);
			const data = {
				action: 'changePassword',
				...Object.fromEntries(formData)
			};

			// Client-side validation
			const newPassword = data.new_password;
			const confirmPassword = data.confirm_password;

			if (newPassword !== confirmPassword) {
				this.showMessage('Новый пароль и подтверждение не совпадают', 'error');
				return false;
			}

			if (newPassword.length < 6) {
				this.showMessage('Пароль должен содержать минимум 6 символов', 'error');
				return false;
			}

			const response = await this.ajax.post(`/ajax.php?mid=${this.mid}`, data, {
				dataType: 'json'
			});

			if (response.success) {
				this.showMessage(response.message || 'Пароль успешно изменён', 'success');

				// Clear form
				form.reset();
			} else {
				this.showMessage(response.error || 'Ошибка при смене пароля', 'error');
			}
		} catch (error) {
			console.error('Error changing password:', error);
			this.showMessage('Ошибка при смене пароля', 'error');
		}

		return false;
	}

	/**
	 * Check if user can delete account (no order history)
	 */
	async checkCanDeleteAccount() {
		try {
			const response = await this.ajax.post(`/ajax.php?mid=${this.mid}`, {
				action: 'checkOrders'
			}, {
				dataType: 'json'
			});

			if (response.success) {
				return {
					canDelete: response.canDelete,
					ordersCount: response.ordersCount
				};
			}
		} catch (error) {
			console.error('Error checking orders:', error);
		}

		return { canDelete: false, ordersCount: 0 };
	}

	/**
	 * Show message to user
	 * @param {string} message - Message text
	 * @param {string} type - Message type (success, error, info)
	 */
	showMessage(message, type = 'info') {
		// Simple alert for now - can be replaced with custom notification system
		if (type === 'error') {
			alert('❌ ' + message);
		} else if (type === 'success') {
			alert('✅ ' + message);
		} else {
			alert(message);
		}

		// Log to console
		console.log(`[Profile] ${type.toUpperCase()}: ${message}`);
	}

	/**
	 * Bind events to dynamically loaded content
	 * @param {HTMLElement} container - Container element
	 */
	bindEvents(container = document) {
		console.log('Binding profile events to container:', container);

		// Bind popup events
		if (window.popupManager) {
			window.popupManager.bindPopupEvents(container);
		}
	}
}
